import { useState } from 'react';
import { Info } from 'lucide-react';
import { categories } from '@/constants/categories';

/**
 * Map Legend Component
 * Shows all category colors with expand/collapse functionality
 */
const MapLegend = () => {
  const [expanded, setExpanded] = useState(false);
  
  return (
    <div className="absolute bottom-24 left-12 z-[999]">
      <div className="bg-white/95 backdrop-blur-sm rounded-lg shadow-lg overflow-hidden max-h-[300px] overflow-y-auto">
        <button
          onClick={() => setExpanded(!expanded)}
          className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 w-full"
          data-testid="legend-toggle"
        >
          <Info className="w-4 h-4" />
          {expanded ? 'Hide Legend' : 'Legend'}
        </button>
        {expanded && (
          <div className="px-3 pb-3 space-y-1.5 border-t">
            <p className="text-xs text-gray-500 pt-2 font-medium">Marker Colors:</p>
            {categories.filter(c => c.value !== 'all').map(cat => (
              <div key={cat.value} className="flex items-center gap-2 text-xs">
                <div 
                  className="w-3 h-3 rounded-full flex-shrink-0" 
                  style={{ backgroundColor: cat.color }}
                />
                <span className="truncate">{cat.label}</span>
              </div>
            ))}
            <div className="flex items-center gap-2 text-xs pt-1.5 border-t mt-1.5">
              <div 
                className="w-3 h-3 rounded-full border-2 border-dashed border-amber-400 flex-shrink-0" 
                style={{ backgroundColor: '#f59e0b' }}
              />
              <span>Unclaimed</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapLegend;
